import echarts from 'echarts'

export function usageLine() {
  let bgColor = "transparent";
  let color = [
    "#d5d6d6",
    "#cb9539",

  ];
  let echartData = [
    {
      name: "1",
      value1: 100,
      value2: 233,
      value3: 120,
      value4: 253
    },
    {
      name: "2",
      value1: 138,
      value2: 233,
      value3: 158,
      value4: 253
    },
    {
      name: "3",
      value1: 350,
      value2: 200,
      value3: 370,
      value4: 220
    },
    {
      name: "4",
      value1: 173,
      value2: 180,
      value3: 193,
      value4: 200
    },
    {
      name: "5",
      value1: 180,
      value2: 199,
      value3: 200,
      value4: 219
    },
    {
      name: "6",
      value1: 150,
      value2: 233,
      value3: 170,
      value4: 253
    },
    {
      name: "7",
      value1: 180,
      value2: 210,
      value3: 200,
      value4: 230
    },
    {
      name: "8",
      value1: 230,
      value2: 180,
      value3: 250,
      value4: 200
    },
    {
      name: "9",
      value1: 230,
      value2: 180,
      value3: 250,
      value4: 200
    },
    {
      name: "10",
      value1: 230,
      value2: 180,
      value3: 250,
      value4: 200
    }, {
      name: "11",
      value1: 100,
      value2: 233,
      value3: 200,
      value4: 253
    },
    {
      name: "12",
      value1: 138,
      value2: 233,
      value3: 200,
      value4: 253
    },
    {
      name: "13",
      value1: 350,
      value2: 200,
      value3: 370,
      value4: 253
    },
    {
      name: "14",
      value1: 173,
      value2: 180,
      value3: 200,
      value4: 253
    },
    {
      name: "15",
      value1: 180,
      value2: 199,
      value3: 200,
      value4: 253
    },
    {
      name: "16",
      value1: 150,
      value2: 233,
      value3: 200,
      value4: 253
    },
    {
      name: "17",
      value1: 180,
      value2: 210,
      value3: 200,
      value4: 253
    },
    {
      name: "18",
      value1: 230,
      value2: 180,
      value3: 200,
      value4: 253
    },
    {
      name: "19",
      value1: 230,
      value2: 180,
      value3: 200,
      value4: 253
    },
    {
      name: "20",
      value1: 230,
      value2: 180,
      value3: 200,
      value4: 253
    }, {
      name: "21",
      value1: 100,
      value2: 233,
      value3: 200,
      value4: 253
    },
    {
      name: "22",
      value1: 138,
      value2: 233,
      value3: 200,
      value4: 253
    },
    {
      name: "23",
      value1: 350,
      value2: 200,
      value3: 200,
      value4: 253
    },
    {
      name: "24",
      value1: 173,
      value2: 180,
      value3: 200,
      value4: 253
    },
    {
      name: "25",
      value1: 180,
      value2: 199,
      value3: 200,
      value4: 253
    },
    {
      name: "26",
      value1: 150,
      value2: 233,
      value3: 200,
      value4: 253
    },
    {
      name: "27",
      value1: 180,
      value2: 210,
      value3: 200,
      value4: 253
    },
    {
      name: "28",
      value1: 230,
      value2: 180,
      value3: 200,
      value4: 253
    },
    {
      name: "29",
      value1: 230,
      value2: 180,
      value3: 200,
      value4: 253
    },
    {
      name: "30",
      value1: 230,
      value2: 180,
      value3: 200,
      value4: 253
    }
  ];

  let xAxisData = echartData.map(v => v.name);

// eslint-disable-next-line no-irregular-whitespace
//  ["1", "2", "3", "4", "5", "6", "7", "8"]
  let yAxisData1 = echartData.map(v => v.value1);
// [100, 138, 350, 173, 180, 150, 180, 230]
  let yAxisData2 = echartData.map(v => v.value2);
  let yAxisData3 = echartData.map(v => v.value3);
  let yAxisData4 = echartData.map(v => v.value4);
// [233, 233, 200, 180, 199, 233, 210, 180]
  const hexToRgba = (hex, opacity) => {
    let rgbaColor = "";
    let reg = /^#[\da-f]{6}$/i;
    if (reg.test(hex)) {
      rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
        "0x" + hex.slice(3, 5)
      )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
    }
    return rgbaColor;
  }

  var option = {
    backgroundColor: bgColor,
    color: color,
    legend: {
      right: 10,
      top: 10,
      itemHeight: 12,
      itemWidth: 12,
      icon: 'rect',
      textStyle: {
        fontSize: 12,//字体大小
        color: '#c5c5c5'//字体颜色
      },
    },
    tooltip: {
      trigger: "axis",
      show:true,
      axisPointer: {
        type: 'line',
        shadowStyle: {
          color: '#ffffff',
          shadowColor: 'rgba(225,225,225,1)',
          shadowBlur: 5
        }
      }
    },
    grid: {
      top: 40,
      bottom: 0,
      left: 0,
      right: 10,
      containLabel: true
    },
    xAxis: [{
      type: "category",
      boundaryGap: false,
      axisLabel: {
        show:true,
        textStyle: {
          color: "#c5c5c5"
        }
      },
      axisLine: {
        lineStyle: {
          color: "#727475",//x轴轴线颜色
          width: 2
        }
      },
      data: xAxisData
    }],
    yAxis: [{
      type: "value",
      name: '（KWH）',
      axisLabel: {
        textStyle: {
          color: "#c5c5c5"
        }
      },
      nameTextStyle: {
        color: "#666",
        fontSize: 12,
        lineHeight: 40
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: 'rgba(197,197,197,0.3)'
        }
      },
      axisLine: {
        lineStyle: {
          color: "#727475",//x轴轴线颜色
          width: 2
        }
      },
      axisTick: {
        show: false
      }
    }],
    series: [{
      name: "1号楼",
      type: "line",
      smooth: true,
      symbol: "none",
      symbolSize: 8,
      zlevel: 3,
      lineStyle: {
        normal: {
          color: color[0],
          shadowBlur: 3,
          shadowColor: hexToRgba(color[0], 0.5),
          shadowOffsetY: 8,
          width:1
        }
      },
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [{
              offset: 0,
              color: hexToRgba(color[0], 0.3)
            },
              {
                offset: 1,
                color: hexToRgba(color[0], 0.1)
              }
            ],
            false
          ),
          shadowColor: hexToRgba(color[0], 0.1),
          shadowBlur: 10
        }
      },
      data: yAxisData1
    },
      {
      name: "2号楼",
      type: "line",
      smooth: true,
      symbol: "none",
      symbolSize: 8,
      zlevel: 3,
      lineStyle: {
        normal: {
          color: color[1],
          shadowBlur: 3,
          shadowColor: hexToRgba(color[1], 0.5),
          shadowOffsetY: 8,
          width:1
        }
      },
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [{
              offset: 0,
              color: hexToRgba(color[1], 0.3)
            },
              {
                offset: 1,
                color: hexToRgba(color[1], 0.1)
              }
            ],
            false
          ),
          shadowColor: hexToRgba(color[1], 0.1),
          shadowBlur: 10
        }
      },
      data: yAxisData2
    },
      {
        name: "3号楼",
        type: "line",
        smooth: true,
        symbol: "none",
        symbolSize: 8,
        zlevel: 3,
        lineStyle: {
          normal: {
            color: color[0],
            shadowBlur: 3,
            shadowColor: hexToRgba(color[0], 0.5),
            shadowOffsetY: 8,
            width:1
          }
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [{
                offset: 0,
                color: hexToRgba(color[0], 0.3)
              },
                {
                  offset: 1,
                  color: hexToRgba(color[0], 0.1)
                }
              ],
              false
            ),
            shadowColor: hexToRgba(color[0], 0.1),
            shadowBlur: 10
          }
        },
        data: yAxisData3
      },
      {
        name: "4号楼",
        type: "line",
        smooth: true,
        symbol: "none",
        symbolSize: 8,
        zlevel: 3,
        lineStyle: {
          normal: {
            color: color[1],
            shadowBlur: 3,
            shadowColor: hexToRgba(color[1], 0.5),
            shadowOffsetY: 8,
            width:1
          }
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [{
                offset: 0,
                color: hexToRgba(color[1], 0.3)
              },
                {
                  offset: 1,
                  color: hexToRgba(color[1], 0.1)
                }
              ],
              false
            ),
            shadowColor: hexToRgba(color[1], 0.1),
            shadowBlur: 10
          }
        },
        data: yAxisData4
      }]
  };
  return option
}

export function elevatorEcharts() {
  var {data, optionConfig} = {
    data: [
      {name: '已完成', value: 12, itemStyle: {color: '#ffa710'}, startRatio: 0, endRatio: 0.15},
      {name: '待处理', value: 14, itemStyle: {color: '#0296fc'}, startRatio: 0.15, endRatio: 0.4},
      {name: '处理中', value: 8, itemStyle: {color: '#8cdeff'}, startRatio: 0.4, endRatio: 0.65},
    ],
    optionConfig: {},
  };
  const getPie3D = (pieData, internalDiameterRatio) => {
    let series = [];
    let sumValue = 0;
    let startValue = 0;
    let endValue = 0;
    let legendData = [];
    let k =
      typeof internalDiameterRatio !== 'undefined'
        ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio)
        : 1 / 3;

    // 为每一个饼图数据，生成一个 series-surface 配置
    for (let i = 0; i < pieData.length; i++) {
      sumValue += pieData[i].value;

      let seriesItem = {
        name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
        type: 'surface',

        parametric: true,
        wireframe: {
          show: false,
        },
        pieData: pieData[i],
        pieStatus: {
          selected: false,
          hovered: false,
          k: k,
        },
        labelLine: {
          show: false,
        },
        label: {
          show: false,
          // normal: {
          //   position: "inner",
          //   formatter: (params) => {
          //     return params;
          //   },
          // },
        },
        itemStyle: {
          opacity: 1,
        },
      };

      if (typeof pieData[i].itemStyle != 'undefined') {
        let itemStyle = {};

        typeof pieData[i].itemStyle.color != 'undefined' ? (itemStyle.color = pieData[i].itemStyle.color) : null;
        typeof pieData[i].itemStyle.opacity != 'undefined'
          ? (itemStyle.opacity = pieData[i].itemStyle.opacity)
          : null;

        seriesItem.itemStyle = itemStyle;
      }
      series.push(seriesItem);
    }

    // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
    // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
    for (let i = 0; i < series.length; i++) {
      endValue = startValue + series[i].pieData.value;
      // console.log(series[i]);
      series[i].pieData.startRatio = startValue / sumValue;
      series[i].pieData.endRatio = endValue / sumValue;
      series[i].parametricEquation = getParametricEquation(
        series[i].pieData.startRatio,
        series[i].pieData.endRatio,
        false,
        false,
        k,
        series[i].pieData.value
      );

      startValue = endValue;

      legendData.push(series[i].name);
    }

    // 准备待返回的配置项，把准备好的 legendData、series 传入。
    let option = {
      tooltip: {

        show: true,
        formatter: (params) => {
          if (params.seriesName !== 'mouseoutSeries') {
            return `${
              params.seriesName
            }<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
              params.color
            };"></span>${option.series[params.seriesIndex].pieData.value}`;
          }
        },
      },

      labelLine: {
        show: true,
      },
      label: {
        show: true,
      },
      legend: {
        orient: 'vertical',
        show: false,
        data: legendData,
        textStyle: {
          color: 'rgba(150,202,223)',
          fontSize: 12,
        },
        itemWidth: 10,
        itemHeight: 10,
        icon: 'roundRect',
        formatter: function (name) {
          let item = data.filter((item) => item.name == name)[0];
          return `${item.name}  ${item.value}%`;
        },
        left: 'right',
        top: '30%', //居右显示
      },
      xAxis3D: {
        min: -0.5,
        max: 0.5,
      },
      yAxis3D: {
        min: -0.5,
        max: 0.5,
      },
      zAxis3D: {
        min: -0,
        max: 0,
      },
      grid3D: {
        show: false,
        boxHeight: 5,
        top: '0%',
        left: '0%',
        // environment: "#021041",
        viewControl: {
          distance: 2000,
          alpha: 15,
          beta: 40,
        },
      },
      series: series,
    };
    return option;
  };
// 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
  const getParametricEquation = (startRatio, endRatio, isSelected, isHovered, k, height) => {
    // 计算
    let midRatio = (startRatio + endRatio) / 2;

    let startRadian = startRatio * Math.PI * 2;
    let endRadian = endRatio * Math.PI * 2;
    let midRadian = midRatio * Math.PI * 2;

    // 如果只有一个扇形，则不实现选中效果。
    if (startRatio === 0 && endRatio === 1) {
      isSelected = false;
    }

    // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
    k = typeof k !== 'undefined' ? k : 1 / 3;

    // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
    let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
    let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;

    // 计算高亮效果的放大比例（未高亮，则比例为 1）
    let hoverRate = isHovered ? 1.05 : 1;

    // 返回曲面参数方程
    return {
      u: {
        min: -Math.PI,
        max: Math.PI * 3,
        step: Math.PI / 32,
      },

      v: {
        min: 0,
        max: Math.PI * 2,
        step: Math.PI / 20,
      },

      x: function (u, v) {
        if (u < startRadian) {
          return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
        }
        if (u > endRadian) {
          return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
        }
        return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
      },

      y: function (u, v) {
        if (u < startRadian) {
          return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
        }
        if (u > endRadian) {
          return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
        }
        return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
      },

      z: function (u, v) {
        if (u < -Math.PI * 0.5) {
          return Math.sin(u);
        }
        if (u > Math.PI * 2.5) {
          return Math.sin(u);
        }
        return Math.sin(v) > 0 ? 1 * height : -1;
      },
    };
  };

  var option = getPie3D(data, 0);

  return option;
}

export function water() {
  var option = {
    title: {
      textStyle: {
        fontWeight: 'normal',
        fontSize: 16,
        color: '#F1F1F3'
      },
      left: '6%'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {

        lineStyle: {
          color: 'rgba(217,146,20, 1)',
          width: 1
        }
      }
    },
    legend: {
      icon: 'rect',
      show: false,
      itemWidth: 14,
      itemHeight: 5,
      itemGap: 13,

      right: '4%',
      textStyle: {
        fontSize: 12,
        color: '#292f39'
      }
    },
    grid: {
      top: '9%',
      left: '0%',
      right: '3%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      axisLine: {
        lineStyle: {
          color: '#c5c5c5'
        },
        textStyle: {
          fontSize: '8'
        }
      },
      axisTick: {
        show: false
      },
      data: ['1', '2', '3', '4', '5', '6', '7']
    }],
    yAxis: [{
      type: 'value',
      axisTick: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: '#c5c5c5'
        },
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          fontSize: 12
        }
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: '#57617B'
        }
      }
    }],
    series: [{
      name: '日供水',
      type: 'line',
      smooth: false,
      symbol: 'circle',
      symbolSize: 5,
      showSymbol: false,
      lineStyle: {
        normal: {
          width: 3
        }
      },
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(217,146,20, 1)'
          }, {
            offset: 1,
            color: 'rgba(217,146,20, 0)'
          }], false),

        }
      },
      itemStyle: {
        normal: {

          color: 'rgba(217,146,20, 1)'
        },
        emphasis: {
          color: 'rgb(255,255,255)',
          borderColor: 'rgba(217,146,20, 0.2)',
          extraCssText: 'box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);',
          borderWidth: 8
        }
      },
      data: [220, 182, 191, 134, 150, 120, 110, 125]
    }]
  };
  return option;
}

export function personnel() {
 var option = {

    tooltip: {
      trigger: 'axis',
      axisPointer: {
        lineStyle: {
          color: '#57617B'
        }
      }
    },
   legend: {
     left:'50%',
     top: 0,
     itemHeight: 12,
     itemWidth: 12,
     icon: 'rect',
     textStyle: {
       fontSize: 12,//字体大小
       color: '#c5c5c5'//字体颜色
     },
   },
    grid: {
      top:'12%',
      left: '0%',
      right: '5%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      axisLine: {
        lineStyle: {
          color: '#c5c5c5'
        }
      },
      data: ['00:00', '06:00', '12:00', '18:00', '24:00']
    }],
    yAxis: [{
      type: 'value',

      axisTick: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: '#c5c5c5'

        }
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          fontSize: 12
        }
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: "#c5c5c5"
        }
      },
    }],
    series: [{
      name: '出',
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 5,
      showSymbol: false,
      lineStyle: {
        normal: {
          width: 1
        }
      },
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(217,146,20, 1)'
          }, {
            offset: 1,
            color: 'rgba(217,146,20, 0)'
          }], false),
        }
      },
      itemStyle: {
        normal: {

          color: 'rgba(217,146,20, 1)'
        },
        emphasis: {
          color: 'rgba(217,146,20, 1)'
        }
      },
      data: [220, 182, 191, 134, 150, 120, 110, 125 ]
    }, {
      name: '入',
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 5,
      showSymbol: false,
      lineStyle: {
        normal: {
          width: 1
        }
      },
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(255,255,255, 1)'
          }, {
            offset: 1,
            color: 'rgba(255,255,255, 0)'
          }], false),
        },
      },
      itemStyle: {
        normal: {
          color: 'rgba(255,255,255, 1)'
        },
        emphasis: {
          color: 'rgba(255,255,255, 1)'
        }
      },
      data: [120, 110, 125, 145, 122, 165, 122, 220]
    }  ]
  };
 return option;
}
